import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import WigDetail from "./pages/WigDetail";
import Privacy from "./pages/Privacy";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";

function App() {
  return (
    <BrowserRouter>
      <div className="app-wrapper">
        <Navbar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/wig/:id" element={<WigDetail />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/bhavdeep" element={<AdminLogin />} />
            <Route path="/bhavdeep/dashboard" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
